import React from 'react'
import PropTypes from 'prop-types'
import { BookingProductType } from '../../propTypes'
import { Copy, Button, Flex, Box, Icon, Currency } from '@elparking/components'

import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

const Container = styled(Box)`
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
`

function ResumeBlock ({
        vehicleFilter,
        vehicleInspectionProduct,
        vehicleInspectionStationName,
        onClick,
    }) {
    return (
        <Container p='1em' bg='lightGray20'>
            <Flex w='100%' flexWrap='wrap' justifyContent='space-between'>
                <Box flex='1' style={{ minWidth: 0 }}>
                    <Copy.truncate size='small' fontWeight='medium' padding='0'>
                        {vehicleInspectionStationName}
                    </Copy.truncate>
                </Box>
                <Box flex='0 1 auto'>
                    <Button.unstyled onClick={onClick}>
                        <Icon type='arrow-up' color='main' size='xLarge' />
                    </Button.unstyled>
                </Box>
            </Flex>
            { vehicleFilter
                ? <Flex alignItems='center'>
                    <Copy.truncate size='small' padding='0' fontWeight='regular'>{vehicleFilter}</Copy.truncate>
                    <Copy as='span' color='gray20' size='small' padding='0 4px' fontWeight='regular'>{'|'}</Copy>
                    <Currency qty={vehicleInspectionProduct.totalPrice} />
                </Flex>
                : <FormattedMessage defaultMessage='Selecciona el tipo de vehículo' />
            }
        </Container>
    )
}

ResumeBlock.propTypes = {
    vehicleFilter: PropTypes.object,
    vehicleInspectionProduct: BookingProductType,
    vehicleInspectionStationName: PropTypes.string,
    onClick: PropTypes.func,
}

ResumeBlock.defaultProps = {
    onClick: () => {},
    bookingProduct: null,
}

export default ResumeBlock
